var a={black:"#000",white:"#fff"};export{a as default};
//# sourceMappingURL=common.js.map
